//! @ngInject
export function clockinClockoutBulkLinkModalCtrl(
      $rootScope,
      $scope,
      $q,
      $uibModalInstance,
      ClockinClockoutService,
      NgTableParams,
      tableData,
      tableColumns,
      clockinClockoutRecord,
      selectionLogic,
      mfModal,
      toaster
    ) {
      initialize();
      $scope.CallTypes = ['IN', 'OUT'];

      function initialize() {
        $scope.clockinClockoutRecord = clockinClockoutRecord;
        $scope.isProcessing = false;
        $scope.tableData = tableData;
        $scope.tableColumns = tableColumns;
        initSelection(tableData);
        initTable();
      }

      function initTable() {
        const options = {
          count: 10,
          sorting: { createdAt: "desc" },
        };
        $scope.tableParams = new NgTableParams(options, {
          dataset: tableData,
        });
      };

      function initSelection(items) {
        $scope.selectionLogic = selectionLogic.createNewLogic((item) => {
          $scope.selectionLogic.addItemToCollection(item);
        });

        if (items) {
          items.forEach((item) => {
            $scope.selectionLogic.initItem(item);
          });
        }
      };

      // Bulk linking sends no duties, so an OUT call whose visit requires them
      // cannot be resolved here — the server would refuse it anyway. Point the
      // coordinator at the single-call modal, which has the duty picker.
      function findOutCallsRequiringDuties(calls) {
        const outCalls = calls.filter(
          (call) => call.callType === "OUT" && (call.potentialLinks || []).length > 0
        );

        if (outCalls.length === 0) {
          return $q.when([]);
        }

        return $q
          .all(
            outCalls.map((call) =>
              ClockinClockoutService.getVisitDutyRequirement(call.id, {
                agencyId: $rootScope.agencyId,
                agencyMemberId: $rootScope.agencyMemberId,
                visitInstanceId: call.potentialLinks[0].visitInstance.id
              }).then(({ data }) =>
                data.dutiesRequired === true && (data.duties || []).length > 0 ? call : null
              )
            )
          )
          .then((results) => results.filter((call) => call !== null));
      }

      $scope.promptLinkAlert = () => {
        $scope.isProcessing = true;

        findOutCallsRequiringDuties($scope.selectionLogic.getSelectedItems())
          .then((callsRequiringDuties) => {
            if (callsRequiringDuties.length > 0) {
              const ids = callsRequiringDuties.map((call) => call.id).join(", ");
              const modal = mfModal.create({
                subject: "Duties required",
                variant: "warning",
                message:
                  `These OUT calls are on visits whose office requires duties on clock-out ` +
                  `(call ${ids}). Link them one at a time so the duties performed can be selected.`,
                hideCancelButton: true,
                confirmLabel: "Got it",
                onConfirm: () => modal.close(),
                onComplete: () => modal.close()
              });
              return;
            }

            const modal = mfModal.create({
              subject: "Link Calls",
              variant: "info",
              message: "Are you sure you want to link these calls?",
              hideCancelButton: false,
              confirmLabel: "Yes, link",
              onConfirm: () => linkCalls(),
              onComplete: () => modal.close()
            });
          })
          .catch((error) => onFailAction({ type: "fail", action: "link", error }))
          .finally(() => ($scope.isProcessing = false));
      };

      $scope.promptRejectAlert = () => {
        const modal = mfModal.create({
          subject: "Reject Calls",
          variant: "warning",
          message: "Are you sure you want to reject these calls?",
          hideCancelButton: false,
          confirmLabel: "Yes, reject",
          onConfirm: () => rejectCalls(),
          onComplete: () => modal.close()
        });
      };

      $scope.handleChangeCallType = (call) => {
        const oppositeCallType = call.callType === "IN" ? "OUT" : "IN";
        const modal = mfModal.create({
          subject: "Change call type",
          variant: "info",
          message: `Are you sure you want to change the call type from ${oppositeCallType} to ${call.callType}?`,
          hideCancelButton: false,
          confirmLabel: "Yes, change",
          onConfirm: () => sendUpdateCallType(call),
          onComplete: () => modal.close(),
          onCancel: () => {
            call.callType = oppositeCallType;
          },
        });
      };

      function sendUpdateCallType(call) {
        $scope.isProcessing = true;
        return ClockinClockoutService.update(call.id, {
          agencyId: $rootScope.agencyId,
          agencyMemberId: $rootScope.agencyMemberId,
          data: {
            callType: call.callType
          }
        })
          .then(() => onSuccessAction({ type: "success", action: "update" }))
          .catch((error) => onFailAction({ type: "fail", action: "update", error }))
          .finally(() => ($scope.isProcessing = false));
      }

      function linkCalls() {
        $scope.isProcessing = true;
        return ClockinClockoutService.linkCalls($rootScope.agencyId, $rootScope.agencyMemberId,
          $scope.selectionLogic.getSelectedItems().map(call => ({ clockinClockoutRecordId: call.id, visitInstanceId: call.potentialLinks[0].visitInstance.id })))
          .then(() => onSuccessAction({ type: "success", action: "link", linkedCalls: $scope.selectionLogic.getSelectedItems() }))
          .catch((error) => onFailAction({ type: "fail", action: "link", error }))
          .finally(() => ($scope.isProcessing = false));
      }

      function rejectCalls() {
        $scope.isProcessing = true;
        return ClockinClockoutService.rejectCalls({
          records: $scope.selectionLogic.getSelectedItems().map(record => record.id),
          agencyId: $rootScope.agencyId,
          agencyMemberId: $rootScope.agencyMemberId
        })
          .then(() => onSuccessAction({ type: "success", action: "reject", linkedCalls: $scope.selectionLogic.getSelectedItems() }))
          .catch((error) => onFailAction({ type: "fail", action: "reject", error }))
          .finally(() => ($scope.isProcessing = false));
      }

      function onSuccessAction(response) {
        toaster.pop("succes", "Success", `Calls ${response.action} has done successfully`);
        response.action !== "update" && $uibModalInstance.close(response);
      }

      function onFailAction({ type: _type, action: _action, error }) {
        console.error(error);
        toaster.pop("error", "Something went wrong", `Could not ${_action} calls`);
      }

      $scope.closeModal = () => {
        $uibModalInstance.close({ type: "close" });
      }
    }
